// extracted by mini-css-extract-plugin
export default {"mainWrap":"ImpressumPage_mainWrap__aj+Gt cobe-globals_mainWrap__qu6Pq","container":"ImpressumPage_container__L5E4-","pageTitle":"ImpressumPage_pageTitle__FMRRW"};